
export const getTextColor = (label: string, value: string): string => {
    const lower = value.toLowerCase();

    //If it’s literally "unknown", always gray:
    if (lower === "unknown") {
      return "font-medium text-semantic-text-secondary";
    }
    const importantFields = ["LAG status", "Subscription Status", "Physical Status", "Auto renew", "Logical Status", "Service Status"];
    const membersField = "Members";
  
    if (importantFields.includes(label)) {
      if (
        lower === "active" ||
        lower === "up" ||
        lower === "yes" ||
        lower === "available"
      ) {
        return "font-medium text-semantic-text-brand";
      }
      if (lower === "warning") {
        return "font-medium text-yellow-600";
      }
      return "font-medium text-semantic-text-danger";
    }
  
    if (label === membersField) {
      return "font-medium text-semantic-text-brand ";
    }
  
    return "text-semantic-text-secondary";
  };
  